import { z } from 'zod';

export type UserNotificationSettingUpdateForm = {
    symbolic_code: string,
    active: 0 | 1,
};

export type UserNotificationSettingsUpdateForm = {
    notification_settings: UserNotificationSettingUpdateForm[],
};

export type UserNotificationSettingUpdateFormErrors = {
    symbolic_code?: string[],
    active?: string[],
};

export type UserNotificationSettingsUpdateFormErrors = {
    notification_settings?: UserNotificationSettingUpdateFormErrors[],
};

export const UserNotificationSettingUpdateFormErrorsSchema = z.object({
    symbolic_code: z.string().array().optional(),
    active: z.string().array().optional(),
});

export const UserNotificationSettingsUpdateFormErrorsSchema = UserNotificationSettingUpdateFormErrorsSchema.array().optional();
